import { render, staticRenderFns } from "./OtpComponent.vue?vue&type=template&id=3819bda4&scoped=true&"
import script from "./OtpComponent.vue?vue&type=script&lang=js&"
export * from "./OtpComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3819bda4",
  null
  
)

export default component.exports